import * as actionTypes from "./actionTypes";

export const sellItem = (
  resourceId: number | string,
  amount: number,
  marketType: string
) => ({
  type: actionTypes.SELL_ITEM,
  resourceId,
  amount,
  marketType
})

export const cancelItem = (
  itemId: number
) => ({
  type: actionTypes.CANCEL_MARKET_ITEM,
  itemId
})

export const buyItem = (
  itemId: number | string,
  amount?: number
) => ({
  type: actionTypes.BUY_ITEM,
  itemId,
  amount
})
